import { TranskodeBundleComponentType } from "./transkode-bundle-component-type";
import { TranskodeBundleComponentSubType } from "./transkode-bundle-component-sub-type";
import { DbCultureInfos } from "./db-culture-infos";
import { TranskodeBundleAsset } from "./transkode-bundle-asset";
import { TranskodeGenericOptionsProfile } from "./transkode-generic-options-profile";

export class TranskodeBundleComponent {
  objectId: number | null = 0;
  isAvailable: boolean | null = null;
  type: TranskodeBundleComponentType | null = null;
  subType: TranskodeBundleComponentSubType | null = null;
  contentTypes: string[] | null = null;
  minItems: number | null = 0;
  maxItems: number | null = 0;
  countries: DbCultureInfos[] | null = null;
  assets: TranskodeBundleAsset[] | null = null;
  summarizedInfos: string | null = null;
  isMandatory: boolean | null = null;
  overrideDoNotUseTextless: boolean = false;
  overrideDoNotUseDubCard: boolean = false;
  overrideDoNotUseRestorationCard: boolean = false;
  specificVendorIdRequired: boolean = false;
  specificVendorId: string | null = null;
  transcodeGenericOptionsProfile: TranskodeGenericOptionsProfile | null = null;

  constructor(init?: Partial<TranskodeBundleComponent>) {
    Object.assign(this, init);
  }
}
